import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

/**
 * Busca as lojas ativas da base de dados (entidade Store).
 * Os dados (morada, horários, telefone) são geridos no backoffice
 * e aparecem automaticamente no rodapé e páginas públicas.
 */
export function useStoreInfo() {
  return useQuery({
    queryKey: ['stores-active-info'],
    queryFn: () => base44.entities.Store.filter({ active: true }),
    staleTime: 1000 * 60 * 10,
  });
}